import React from 'react';
import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { Text } from '../Typography';

interface InviteCardProps {
  role: string;
  entity?: string;
  className?: string;
}

const Layout = styled.li`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${toRem(275)};
  height: auto;
  min-height: ${toRem(120)};
  margin-bottom: ${toRem(theme.space.md)};
  padding: ${toRem(theme.space.xl)} ${toRem(theme.space.xl)};
  border: ${toRem(1)} solid ${theme.color.neutral[100]};
  border-radius: ${toRem(11)};
  background-color: ${theme.color.neutral[50]};
  list-style: none;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Role = styled.h2`
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.bold};
  font-size: ${toRem(theme.font.size.xl)};
  line-height: ${lineHeight(theme.font.size.xl)};
  color: ${theme.color.neutral[900]};
`;

const Entity = styled(Text).attrs({ size: 'default' })`
  margin-top: ${toRem(theme.space.sm)};
  font-weight: ${theme.font.weight.medium};
  word-break: break-all;
`;

const InviteCard: React.FC<InviteCardProps> = ({ role, entity, className, ...rest }) => (
  <Layout className={className} {...rest}>
    <Role data-cy="role">{role}</Role>
    <Entity data-cy="entity">{entity}</Entity>
  </Layout>
);

export default InviteCard;
